import { render, staticRenderFns } from "./DrawerInvestorProfile.vue?vue&type=template&id=95de0c84"
import script from "./DrawerInvestorProfile.vue?vue&type=script&lang=js"
export * from "./DrawerInvestorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports